import dayjs from 'dayjs';

export const dateDisabled = (current: dayjs.Dayjs, type?: string) => {
  if (type === 'before') {
    return current && current.isBefore(dayjs()?.startOf('day'));
  } else if (type === 'after') {
    return current.isAfter(dayjs()?.endOf('day'));
  }
  return (
    current &&
    (current.isBefore(dayjs()?.startOf('day')) ||
      current.isAfter(dayjs()?.endOf('day')))
  );
};
